import React from 'react';
const Footer=()=>{
    const style = {
        width : "100%",
        backgroundColor : "#483d8b",
        textAlign : "center",
        padding : "10px",
    }
    return <div style={style}></div>
}
export default Footer